export default "/assets/images/mila-air-specs.webp?b9e95382aa7fc6789c51130ac5909307";